export const formatSymbol = (symbol) => {
  if (!symbol || typeof symbol !== 'string') return symbol;

  // Handle -EQ (Stocks)
  if (symbol.endsWith('-EQ')) {
    const base = symbol.slice(0, -3);
    // Special formatting for common indices if they appear as stocks
    if (base === 'RELIANCE') return 'Reliance';
    if (base === 'HDFCBANK') return 'HDFC Bank';
    if (base === 'TCS') return 'TCS';
    return base.charAt(0).toUpperCase() + base.slice(1).toLowerCase();
  }

  // Handle Space-Separated Format (FnO)
  // Example: "NIFTY 27350 CE 30 MAR 2026"
  const parts = symbol.split(' ');
  
  if (parts.length >= 4) {
    const underlying = parts[0].toUpperCase();
    let formattedUnderlying = underlying;

    // Format underlying for readability
    if (underlying === 'NIFTY') formattedUnderlying = 'Nifty';
    else if (underlying === 'BANKNIFTY') formattedUnderlying = 'BankNifty';
    else if (underlying === 'SENSEX') formattedUnderlying = 'Sensex';
    else if (underlying === 'BANKEX') formattedUnderlying = 'Bankex';
    else formattedUnderlying = underlying.charAt(0).toUpperCase() + underlying.slice(1).toLowerCase();

    // Check if it's an Option (has CE/PE)
    const typeIndex = parts.findIndex(p => p === 'CE' || p === 'PE');
    if (typeIndex !== -1) {
      const strike = parts[1];
      const type = parts[typeIndex];
      const expiry = parts.slice(typeIndex + 1).join('-');
      // Convert "30-MAR-2026" to "30 Mar 2026" or similar
      const formattedExpiry = expiry.split('-').map(p => 
        p.charAt(0).toUpperCase() + p.slice(1).toLowerCase()
      ).join(' ');
      
      return `${formattedUnderlying} ${formattedExpiry} ${strike} ${type}`;
    }

    // Check if it's a Future (ends with FUT)
    if (parts[parts.length - 1] === 'FUT') {
      const expiry = parts.slice(1, parts.length - 1).join(' ');
      const formattedExpiry = expiry.split(' ').map(p => 
        p.charAt(0).toUpperCase() + p.slice(1).toLowerCase()
      ).join(' ');
      return `${formattedUnderlying} ${formattedExpiry} FUT`;
    }
  }

  // Fallback for current format (NIFTY20MAR2623850CE) if still present
  const fnoRegex = /^([A-Z\s]+)(\d{2})([A-Z]{3})(\d{2})(\d+)([CP]E)$/;
  const futRegex = /^([A-Z\s]+)(\d{2})([A-Z]{3})(\d{2})FUT$/;

  const fnoMatch = symbol.match(fnoRegex);
  if (fnoMatch) {
    const [, base, day, month, year, strike, type] = fnoMatch;
    let formattedBase = base.trim() === 'NIFTY' ? 'Nifty' : base.trim().charAt(0).toUpperCase() + base.trim().slice(1).toLowerCase();
    const formattedMonth = month.charAt(0).toUpperCase() + month.slice(1).toLowerCase();
    return `${formattedBase} ${day}-${formattedMonth}-${year} ${strike} ${type}`;
  }

  return symbol;
};
